const LVSavingsDark = () => (
	<g id="LT_Savings, Lovet">
		<g id="Group">
			<path
				id="Vector"
				d="M6.25857 12.2192C4.92857 11.6892 3.07928 9.63312 4.66928 8.66312C5.22928 8.32312 6.06928 8.69312 5.72928 9.69312C4.84928 12.3331 2.28928 11.8731 2.08928 9.19312"
				stroke="#00084D"
				strokeWidth="0.75"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				id="Vector_2"
				d="M18.9793 8.61322H10.9893C10.9893 8.61322 4.70929 8.58322 5.69929 16.6532C6.38929 22.2632 7.59929 24.2432 8.21929 25.9532C8.46929 26.6332 9.09928 27.0832 9.81928 27.0832H13.0093C13.3993 27.0832 13.7093 26.7732 13.7093 26.3832C13.7093 25.3132 14.5793 23.5732 15.6593 23.5732H17.1193C18.1893 23.5732 19.0693 25.3132 19.0693 26.3832C19.0693 26.7732 19.3793 27.0832 19.7693 27.0832H23.0893C23.8593 27.0832 24.5393 26.5632 24.7393 25.8132L26.2793 19.9732L27.2793 19.6632C28.8893 19.1632 29.9093 17.8532 29.9093 16.1532V14.7632C29.9093 13.9232 29.3593 13.2032 28.2293 13.2032C28.2293 13.2032 27.1293 13.1532 27.0493 12.8332C26.3893 10.0232 25.2893 9.71322 24.1693 8.81322C23.4893 8.27322 23.7693 6.39322 24.0493 5.26322C24.3293 4.13322 18.9793 5.90322 18.9793 8.61322Z"
				fill="#AAE2F7"
			/>
			<path
				id="Vector_3"
				d="M23.4193 13.4432C23.8893 13.4432 24.2593 13.0632 24.2593 12.6032C24.2593 12.1432 23.8793 11.7632 23.4193 11.7632C22.9593 11.7632 22.5793 12.1432 22.5793 12.6032C22.5793 13.0632 22.9593 13.4432 23.4193 13.4432Z"
				fill="#00084D"
			/>
			<path
				id="Vector_4"
				d="M17.8993 10.1532C17.8993 8.17323 16.2893 6.56323 14.3093 6.56323C12.3293 6.56323 10.7193 8.17323 10.7193 10.1532H17.8993Z"
				fill="#2CA757"
			/>
			<path
				id="Vector_5"
				d="M9.95927 10.2532H18.4093"
				stroke="#00084D"
				strokeWidth="0.75"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				id="Vector_6"
				d="M22.1893 7.14322C22.1893 7.14322 21.1493 7.60322 21.0193 8.97322"
				stroke="#00084D"
				strokeWidth="0.75"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</g>
);

export default LVSavingsDark;
